// src/components/HowItWorks.js
import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  VStack,
  HStack,
  Icon,
  Image,
  useColorModeValue,
  Circle,
  Button,
} from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom'; // <<< ADD THIS IMPORT

// Using a placeholder - you would replace this with your actual image file
const excavatorImage = 'https://i.imgur.com/your-image-code.png'; // Use a direct URL to a PNG image or import from assets

const LearnMoreButton = () => {
    // This component might not exist in your version, I'm using a standard button to match the screenshot
    return (
        <Button
            rightIcon={<ArrowForwardIcon />}
            colorScheme="orange"
            variant="solid"
            size="lg"
                 as={RouterLink}      // <<-- ADD THIS
            to="/process"   
          >
            Learn More
          </Button>
    )
};

const StepSeparator = () => {
    return (
        <Flex
            justify="center"
            align="center"
            px={8}
            py={{ base: 6, md: 0 }}
            display={{ base: 'none', md: 'flex' }}
          >
            <Icon as={ArrowForwardIcon} color="orange.400" boxSize={6} />
          </Flex>
    )
}


export default function HowItWorks() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const textColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box as="section" bg={bgColor} py={{ base: 16, md: 24 }}>
      <Box maxW="7xl" mx="auto" px={8}>
        {/* Section Header */}
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align={{ base: 'flex-start', md: 'center' }}
          mb={16}
        >
          <VStack align="flex-start" spacing={3}>
            <Text color="orange.500" fontWeight="bold">How We Works</Text>
            <Heading as="h2" size="2xl" fontWeight="bold" color={useColorModeValue('blue.900', 'white')}>
              How We Get It Done
            </Heading>
          </VStack>
          <Box mt={{ base: 4, md: 0 }}>
            <LearnMoreButton />
          </Box>
        </Flex>

        {/* Process Steps Layout */}
        <Flex direction={{ base: 'column', md: 'row' }} align="flex-start" justify="space-between" gap={8}>
          
          {/* Step 1 */}
          <VStack align="flex-start" spacing={4} flex="1">
              <Text bg="blue.800" color="white" px={4} py={1} borderRadius="md" fontSize="sm" fontWeight="bold">
                STEP 1
              </Text>
              <Heading as="h3" size="lg" fontWeight="bold" color={useColorModeValue('blue.900', 'white')}>
                Consultation & Planning
              </Heading>
              <Text color={textColor} fontSize="md">
                We start by understanding your vision, defining project goals, and creating a detailed roadmap for success.
              </Text>
          </VStack>
          
          <StepSeparator />

          {/* Step 2 */}
          <VStack align="flex-start" spacing={4} flex="1" pt={{md: 0}} borderLeft={{ base: 'none', md: '1px' }} borderColor="gray.200" pl={{md: 8}}>
             <Text bg="blue.800" color="white" px={4} py={1} borderRadius="md" fontSize="sm" fontWeight="bold">
                STEP 2
              </Text>
              <Heading as="h3" size="lg" fontWeight="bold" color={useColorModeValue('blue.900', 'white')}>
                Design & Construction
              </Heading>
              <Text color={textColor} fontSize="md">
                With the design approved, our skilled crews begin construction, ensuring every detail meets our high standards.
              </Text>
          </VStack>

          <StepSeparator />
          
          {/* Step 3 */}
           <VStack align="flex-start" spacing={4} flex="1" pt={{md: 0}} borderLeft={{ base: 'none', md: '1px' }} borderColor="gray.200" pl={{md: 8}}>
            <Text bg="blue.800" color="white" px={4} py={1} borderRadius="md" fontSize="sm" fontWeight="bold">
                STEP 3
              </Text>
              <Heading as="h3" size="lg" fontWeight="bold" color={useColorModeValue('blue.900', 'white')}>
                Final Inspection & Handover
              </Heading>
              <Text color={textColor} fontSize="md">
                The project concludes with a comprehensive walkthrough and final inspection, ensuring your total satisfaction.
              </Text>
          </VStack>

        </Flex>
      </Box>
    </Box>
  );
}